import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { NgbDropdownButtonItem, NgbDropdownItem } from '@ng-bootstrap/ng-bootstrap';
import { ContextMenuComponent, PanelComponent, PanelHeaderComponent, TitleComponent } from '@rocksoft/cdk';
import { User } from '@rocksoft/security-sdk';
import { MembershipListGroupItemsContainerComponent } from '../../groups/list-group-items/membership-list-group-items.container';

@Component({
  selector: 'era-security-membership-list-ui',
  templateUrl: './membership-list.component.html',
  styleUrls: ['./membership-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    PanelComponent,
    PanelHeaderComponent,
    TitleComponent,
    ContextMenuComponent,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    MembershipListGroupItemsContainerComponent,
  ],
})
export class MemberShipListComponent {
  public readonly user = input<User>();
  public readonly editEnabled = input<boolean>();

  public readonly toggleEditEvent = output();
  public readonly addGroupEvent = output();

  toggleEdit() {
    this.toggleEditEvent.emit();
  }

  addGroup() {
    this.addGroupEvent.emit();
  }
}
